// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"Modal_modalWrapper__2lhhH","modal":"Modal_modal__1259S","calculationSettings":"Modal_calculationSettings__3N8bT"};